import React from 'react';
import PatientForm from './PatientForm';
import '../styles/Modal.css';

function PatientModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add New Patient</h2>
          <button className="modal-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="modal-body">
          <PatientForm onSuccess={onClose} />
        </div>
      </div>
    </div>
  );
}

export default PatientModal;
